import { Flex, Box } from "@chakra-ui/react";
import Select from "./Select";
import TextField from "src/components/TextField";
import { H4 } from "src/atoms/typography";
import icons from "src/modules/command/commands-icons";
import colors from "src/modules/command/colors";
import IconOnBackgound from "src/components/IconOnBackground";
import SvgContainer from "src/components/SvgContainer";
import { ReactComponent as DoneIcon } from "./done.svg";

export default function InputFields({
  command,
  t,
  onNameChange,
  onIconChange,
  onColorChange,
  on
}) {
  const { name, icon: currentIconName, color: currentColorName } = command;

  const selectedIcon = (
    <SvgContainer
      icon={icons[currentIconName].icon}
      fill="lowEmphasis"
      size="20px"
    />
  );
  const iconComponents = Object.values(icons).map(({ icon, name }, i) => (
    <IconOnBackgound
      key={name + i}
      icon={icon}
      size="32px"
      iconSize="20px"
      bg={
        name === currentIconName
          ? colors[currentColorName].name
          : "iconBackground"
      }
      fill={name === currentIconName ? "white" : "mediumEmphasis"}
      onClick={() => onIconChange(name)}
    />
  ));

  const selectedColor = (
    <Box borderRadius="100%" p="8px" bg={colors[currentColorName].name} />
  );
  const colorComponents = Object.values(colors).map(({ name }, i) =>
    name === currentColorName ? (
      <IconOnBackgound
        key={name + i}
        size="32px"
        iconSize="16px"
        fill="white"
        bg={name}
        icon={DoneIcon}
        onClick={() => onColorChange(name)}
      />
    ) : (
      <Flex
        key={name + i}
        borderRadius="100%"
        onClick={() => onColorChange(name)}
        bg={name}
        p="16px"
      />
    )
  );

  return (
    <Box>
      <Box>
        <H4 color="highEmphasis" mb="8px">
          {t("command.editor.iconAndColor")}
        </H4>
        <Flex>
          <Select
            root={{ mr: "16px" }}
            selectedItem={selectedIcon}
            onChange={onIconChange}
            items={iconComponents}
          />
          <Select
            selectedItem={selectedColor}
            items={colorComponents}
            onChange={onColorChange}
          />
        </Flex>
      </Box>
      <Box mt="33px">
        <H4 color="highEmphasis" mb="8px">
          {t("setName")}
        </H4>
        <TextField
          name="name"
          value={name}
          placeholder={t(`command.name.${currentIconName}`)}
          type="text"
          onChange={onNameChange}
        />
      </Box>
    </Box>
  );
}
